/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.panel()
    export class SettingUserDialog extends NoboxEntityDialog<UserRow, any> {
        protected getFormKey() { return SettingUserForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }
        protected getDeletePermission() { return UserRow.deletePermission; }
        protected getInsertPermission() { return UserRow.insertPermission; }
        protected getUpdatePermission() { return UserRow.updatePermission; }

        protected form = new SettingUserForm(this.idPrefix);
        private loadedState: string;
        private prevFormatNumber = {};
        constructor(container?: JQuery) {
            super(container);
            var $this = this;
            this.applyChangesButton.hide();
            Serenity.Extensions.DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            $this.form.TenantId.element.parent(".field").find(".select2-arrow").hide();
            var initFile = false;
            this.form.UserImage.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        };
        protected updateInterface() {
            super.updateInterface();
            var $this = this;
            var thisTime = moment();
            if ($this.get_entity().FormatDate == "CustomDate") {
                Serenity.EditorUtils.setReadOnly($this.form.CustomDate, false);
                Serenity.EditorUtils.setValue($this.form.CustomDate, $this.get_entity().CustomDate);
                Serenity.EditorUtils.setValue($this.form.DisplayDate, thisTime.format($this.get_entity().CustomDate));
            } else {
                Serenity.EditorUtils.setReadOnly($this.form.CustomDate, true);
                Serenity.EditorUtils.setValue($this.form.CustomDate, $this.form.FormatDate.value);
                Serenity.EditorUtils.setValue($this.form.DisplayDate, thisTime.format($this.form.FormatDate.value));
            }
            $this.form.FormatDate.getGridField().on("change", function () {
                var val = $this.form.FormatDate.value;
                if (val == "CustomDate") {
                    Serenity.EditorUtils.setReadOnly($this.form.CustomDate, false);
                } else {
                    Serenity.EditorUtils.setReadOnly($this.form.CustomDate, true);
                    Serenity.EditorUtils.setValue($this.form.CustomDate, val);
                    Serenity.EditorUtils.setValue($this.form.DisplayDate, thisTime.format(val));
                }
            });
            $this.form.CustomDate.getGridField().on("keyup", function (e) {
                Serenity.EditorUtils.setValue($this.form.DisplayDate, thisTime.format($this.form.CustomDate.value));
            });

            //Time
            if ($this.get_entity().FormatTime == "CustomTime") {
                Serenity.EditorUtils.setReadOnly($this.form.CustomTime, false);
                Serenity.EditorUtils.setValue($this.form.CustomTime, $this.get_entity().CustomTime);
                Serenity.EditorUtils.setValue($this.form.DisplayTime, thisTime.format($this.get_entity().CustomTime));
            } else {
                Serenity.EditorUtils.setReadOnly($this.form.CustomTime, true);
                Serenity.EditorUtils.setValue($this.form.CustomTime, $this.form.FormatTime.value);
                Serenity.EditorUtils.setValue($this.form.DisplayTime, thisTime.format($this.form.FormatTime.value));
            }
            $this.form.FormatTime.getGridField().on("change", function () {
                var val = $this.form.FormatTime.value;
                if (val == "CustomTime") {
                    Serenity.EditorUtils.setReadOnly($this.form.CustomTime, false);
                } else {
                    Serenity.EditorUtils.setReadOnly($this.form.CustomTime, true);
                    Serenity.EditorUtils.setValue($this.form.CustomTime, val);
                    Serenity.EditorUtils.setValue($this.form.DisplayTime, thisTime.format(val));
                }
            });
            $this.form.CustomTime.getGridField().on("keyup", function (e) {
                Serenity.EditorUtils.setValue($this.form.DisplayTime, thisTime.format($this.form.CustomTime.value));
            });

            //number
            var formatNumber = JSON.parse(this.get_entity().FormatNumber);
            if (!Q.isEmptyOrNull(formatNumber)) {
                if ('aDec' in formatNumber) {
                    this.form.aDec.set_value(formatNumber["aDec"]);
                }
                if ('mDec' in formatNumber) {
                    this.form.mDec.set_value(formatNumber["mDec"]);
                }
                if ('aSep' in formatNumber) {
                    this.form.aSep.set_value(formatNumber["aSep"]);
                }
                if ('dGroup' in formatNumber) {
                    this.form.dGroup.set_value(formatNumber["dGroup"]);
                }
                if ('lZero' in formatNumber) {
                    this.form.lZero.set_value(formatNumber["lZero"]);
                }
                $this.form.DisplayNumber.value = "017081945";
                $this.form.DisplayNumber.element.autoNumeric('destroy');
                $this.form.DisplayNumber.element.autoNumeric('init', this.optionAutoNumeric());
            }
            else {
                $this.form.aDec.set_value(",");
                $this.form.mDec.set_value(0);
                $this.form.aSep.set_value(".");
                $this.form.dGroup.set_value("3");
                $this.form.lZero.set_value("allow");
                $this.form.Currencies.set_value("Rp");
                $this.form.CurrenciesPlace.set_value("left");
                $this.form.DisplayNumber.value = "017081945";
                $this.form.DisplayNumber.element.autoNumeric('destroy');
                $this.form.DisplayNumber.element.autoNumeric('init');
            }
            $this.form.aDec.change(() => {
                if ($this.form.aDec.value == $this.form.aSep.value) {
                    if ('aDec' in this.prevFormatNumber) {
                        this.form.aDec.set_value(this.prevFormatNumber["aDec"]);
                    } else if ($this.form.aSep.value=="."){
                        $this.form.aDec.set_value(",");
                    }else if ($this.form.aSep.value==","){
                        $this.form.aDec.set_value(".");
                    }
                    Q.notifyError("Decimal Separator and Thousand Separator can't be same");
                } else {
                    $this.form.DisplayNumber.value = "017081945";
                    $this.form.DisplayNumber.element.autoNumeric('update', this.optionAutoNumeric());
                }
            });
            $this.form.mDec.change(() => {
                $this.form.DisplayNumber.value = "017081945";
                $this.form.DisplayNumber.element.autoNumeric('update', this.optionAutoNumeric());
            });
            $this.form.aSep.change(() => {
                if ($this.form.aDec.value == $this.form.aSep.value) {
                    if ('aSep' in this.prevFormatNumber) {
                        this.form.aSep.set_value(this.prevFormatNumber["aSep"]);
                    } else if ($this.form.aDec.value == ".") {
                        $this.form.aSep.set_value(",");
                    } else if ($this.form.aDec.value == ",") {
                        $this.form.aSep.set_value(".");
                    }
                    Q.notifyError("Thousand Separator and Decimal Separator can't be same");
                } else {
                    $this.form.DisplayNumber.value = "017081945";
                    $this.form.DisplayNumber.element.autoNumeric('update', this.optionAutoNumeric());
                }
            });
            $this.form.dGroup.change(() => {
                $this.form.DisplayNumber.value = "017081945";
                $this.form.DisplayNumber.element.autoNumeric('update', this.optionAutoNumeric());
            });
            $this.form.lZero.change(() => {
                $this.form.DisplayNumber.value = "017081945";
                $this.form.DisplayNumber.element.autoNumeric('update', this.optionAutoNumeric());
            });
            this.optionAutoNumeric();
        }
        optionAutoNumeric() {
            var obj = {};
            var aDec = this.form.aDec.value;
            var mDec = this.form.mDec.value;
            var aSep = this.form.aSep.value;
            var dGroup = this.form.dGroup.value;
            var lZero = this.form.lZero.value;

            if (aDec != null) {
                obj["aDec"] = Q.isEmptyOrNull(aDec) ? "." : Q.isEmptyOrNull(aSep) ? "." :aSep=="."?",":aDec;
            }
            if (mDec != null) {
                obj["mDec"] = mDec;
            }
            if (aSep != null) {
                obj["aSep"] = Q.isEmptyOrNull(aSep) ? "," : obj["aDec"] =="."?",": aSep;
            }
            if (dGroup != null) {
                obj["dGroup"] = parseInt(dGroup);
            }
            if (lZero != null) {
                obj["lZero"] = lZero;
            }
            this.form.FormatNumber.value = JSON.stringify(obj);
            this.prevFormatNumber = obj;
            return obj;
        }

        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons[2].visible = false;
            buttons.push({
                title: "Unsubscribe",
                separator: true,
                icon: "fa-times text-danger",
                onClick: () => {
                    if (Q.Authorization.hasPermission("Role:Owner")) {
                        Q.confirm("Are you sure you want to Unsubscribe your account and your tenant?", () => {
                            Q.serviceCall({
                                blockUI: true,
                                url: `/Services/${UserService.baseUrl}/UnSubscribeAndTenant`,
                                onSuccess: () => {
                                    Q.notifySuccess("Successfully Unsubscribe your account and your tenant");
                                    setTimeout(() => {
                                        window.location = "/Account/Signout"
                                    }, 500)
                                }
                            })
                        }, {
                            //title: "Unsubscribe your account"
                        });
                    } else {
                        Q.confirm("Are you sure you want to Unsubscribe your account?", () => {
                            Q.serviceCall({
                                blockUI: true,
                                url: `/Services/${UserService.baseUrl}/UnSubscribe`,
                                onSuccess: () => {
                                    Q.notifySuccess("Successfully Unsubscribe your account");
                                    setTimeout(() => {
                                        window.location = "/Account/Signout"
                                    }, 500)
                                }
                            })
                        }, {
                            //title: "Unsubscribe your account"
                        });
                    }
                }
            })
            return buttons;
        }
        protected save(calback?: (response: Serenity.SaveResponse) => void) {
            if (this.validateForm()) {
                var cokie = document.cookie;
                var value = this.form.Timezone.text;
                cokie = cokie.replace("timezone= " + value + ";", "");
                document.cookie = "timezone=" + value + "; path=/";
                cokie = cokie.replace("formatdate= " + this.form.CustomDate.value + ";", "");
                document.cookie = "formatdate=" + this.form.CustomDate.value + "; path=/";

                cokie = cokie.replace("formattime= " + this.form.CustomTime.value + ";", "");
                document.cookie = "formattime=" + this.form.CustomTime.value + "; path=/";

                cokie = cokie.replace("formatnumber= " + encodeURIComponent(this.form.FormatNumber.value) + ";", "");
                document.cookie = "formatnumber=" + encodeURIComponent(this.form.FormatNumber.value) + "; path=/";
                super.save(calback);
            }
        }
        onSaveSuccess(response: Serenity.SaveResponse) {
            super.onSaveSuccess(response);
            Q.reloadLookup(UserRow.lookupKey);
            Q.notifySuccess("Save success");
            //this.ifExistFormatDate == true ? Serenity.EditorUtils.setValue(this.form.FormatDate, "CustomDate") : "";
        }
        dialogOpen() {
            super.dialogOpen();
            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").find(".panel-titlebar-text").text("User Profile");

            this.element.children("div.panel-titlebar").css("justify-content", "space-between");
            this.element.children("div.panel-titlebar").append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${$('#GridDiv').attr('help-url')}">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a>`);
            Q.Router.replace("");
        }
        dialogClose() {

        }
    }
}